// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1ctU6","select":"Header_select__1iGnW","clinic":"Header_clinic__3yk7e"};